import { type TenantPublicConfig, type TenantPublicConfigServer } from "@/types/tenantConfig";

export const normalizeTenantPublicConfig = (tenantPublicConfig: TenantPublicConfigServer): TenantPublicConfig => {
  return {
    ssoEnabled: tenantPublicConfig.sso_enabled,
    ssoProvider: tenantPublicConfig.sso_provider,
  };
};
